const DEFAULT = 'DEFAULT';
const PENDING = 'PENDING';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

export default class ObservableRequest {
  constructor(request, cancelTokenSource) {
    this.status = request ? PENDING : DEFAULT;
    this.request = request;
    this.cancelTokenSource = cancelTokenSource;
    this.error = null;
  }

  resolve() {
    this.status = SUCCESS;
  }

  reject(error) {
    this.status = FAILURE;
    this.error = error;
  }

  abort() {
    if (this.request && this.cancelTokenSource) {
      this.cancelTokenSource.cancel();
    }
  }

  reset() {
    this.status = DEFAULT;
    this.error = null;
  }

  isDefault() {
    return this.status === DEFAULT;
  }

  isPending() {
    return this.status === PENDING;
  }

  isSuccess() {
    return this.status === SUCCESS;
  }

  isFailure() {
    return this.status === FAILURE;
  }

  getError() {
    return this.error;
  }

  getErrorMessage() {
    return this.error && this.error.message;
  }
}



// WEBPACK FOOTER //
// ./src/decorators/withRequest/ObservedRequest.js